import React from 'react';
import './SleepOverlay.css';

/**
 * SleepOverlay Component
 * Animated "Zzz" overlay for units affected by sleep effects
 * Shows floating Z letters and a status text
 */
function SleepOverlay() {
  return (
    <div className="sleep-overlay">
      {/* Floating Z's */}
      <div className="sleep-zzz-container">
        <span className="sleep-z sleep-z-1">Z</span>
        <span className="sleep-z sleep-z-2">z</span>
        <span className="sleep-z sleep-z-3">z</span>
      </div>
      {/* Status text */}
      <div className="sleep-text">Zzz...</div>
    </div>
  );
}

export default SleepOverlay;
